{
  "confluence-integrations.confluence-devdocs-sync-complete.message-template.notification-drawer.message": [
    {
      "type": 0,
      "value": "Docs created from your code are ready"
    }
  ],
  "confluence-integrations.project-pages-revamp-onboarding-spotlight.body": [
    {
      "type": 0,
      "value": "Pages is now Docs. Access pages, live docs, and more, all from your space."
    }
  ],
  "confluence-integrations.project-pages-revamp-onboarding-spotlight.done-button": [
    {
      "type": 0,
      "value": "Done"
    }
  ],
  "confluence-integrations.project-pages-revamp-onboarding-spotlight.heading": [
    {
      "type": 0,
      "value": "One place for all your project docs"
    }
  ]
}